// translations.ts

export const translations = {
    fi: {
        firstName: "Etunimi",
        lastName: "Sukunimi",
        email: "Sähköposti",
        phoneNumber: "Puhelinnumero",
        gender: "Sukupuoli",
        organization: "Valitse koulu",
        fieldOfStudy: "Koulutusala",
        workingLocations: "Missä voit työskennellä?",
        studyYear: "Opiskeluvuosi",
        typeOfEmployment: "Työsuhteen tyyppi",
        applicationDate: "Millon voit aloittaa?",
        resume: "CV",
        coverLetter: "Hakemuskirje",
        message: "Vapaamuotoinen viesti",
        fullTime: "Kokoaikainen",
        partTime: "Osa-aikainen",
        summerJob: "Kesätyö",
        trainee: "Harjoittelija",
        submit: "Lähetä",
        submittedHeader: "Kiitos hakemuksestasi!",
        submittedHeaderTwo: "Olemme vastaanottaneet hakemuksesi onnistuneesti!",
        openPositions: "Avoimena olevat työpaikat",
        gdpaLabel: "Lähettämällä hakemuksen hyväksyn,",
        gdpaLink: "Nemoran tietosuojaselosteen."
    },
    en: {
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email",
        phoneNumber: "Phone Number",
        gender: "Gender",
        organization: "Select an Organization",
        fieldOfStudy: "Field of Study",
        workingLocations: "Where can you work?",
        studyYear: "Select a study year",
        typeOfEmployment: "Type of Employment",
        applicationDate: "When can you start?",
        resume: "Resume",
        coverLetter: "Cover Letter",
        message: "Open Message",
        fullTime: "Full Time",
        partTime: "Part Time",
        summerJob: "Summer Job",
        trainee: "Trainee",
        submit: "Submit",
        submittedHeader: "Thank you for applying!",
        submittedHeaderTwo: "We have successfully received your submission",
        openPositions: "Our open positions",
        gdpaLabel: "By submitting the application,",
        gdpaLink: "I accept Nemora's privacy policy."
    },
};
